import { makeStyles, tokens } from "@fluentui/react-components";
export const useToastContentStyles = makeStyles({
    dismissIconInverted: {
        color: tokens.colorNeutralForegroundInverted2
    },
    dismissIconDefault: {
        color: tokens.colorNeutralForeground1
    }
});
